/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountId,
  HttpValidationProblemDetails,
  LocationDetailsResponse,
  LocationId,
  LocationRequest,
  RegistrationCompositeId,
  SegmentationId
} from './data.schemas'




/**
 * Creates a location for an account. if the group is changed, it will also update the group on the registration composite
 */
export const createLocation = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    locationRequest: LocationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LocationId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/locations`,
      locationRequest,options
    );
  }



export const getCreateLocationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: LocationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: LocationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: LocationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,data} = props ?? {};

          return  createLocation(segmentationId,accountId,registrationCompositeId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = LocationRequest
    export type CreateLocationMutationError = AxiosError<HttpValidationProblemDetails>

    export const useCreateLocation = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: LocationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: LocationRequest},
        TContext
      > => {

      const mutationOptions = getCreateLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Updates a location for an account. if the group is changed, it will also update the group on the registration composite
 */
export const updateLocation = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    locationId: LocationId,
    locationRequest: LocationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LocationId>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/locations/${encodeURIComponent(String(locationId))}`,
      locationRequest,options
    );
  }



export const getUpdateLocationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId;data: LocationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId;data: LocationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId;data: LocationRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,locationId,data} = props ?? {};

          return  updateLocation(segmentationId,accountId,registrationCompositeId,locationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    export type UpdateLocationMutationBody = LocationRequest
    export type UpdateLocationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useUpdateLocation = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId;data: LocationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId;data: LocationRequest},
        TContext
      > => {

      const mutationOptions = getUpdateLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a location for an account
 */
export const deleteLocation = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    locationId: LocationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/locations/${encodeURIComponent(String(locationId))}`,options
    );
  }



export const getDeleteLocationMutationOptions = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocation>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,locationId} = props ?? {};

          return  deleteLocation(segmentationId,accountId,registrationCompositeId,locationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocation>>>
    
    export type DeleteLocationMutationError = AxiosError<string>

    export const useDeleteLocation = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteLocation>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;locationId: LocationId},
        TContext
      > => {

      const mutationOptions = getDeleteLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get location details
 */
export const locationDetails = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    locationId: LocationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LocationDetailsResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/locations/${encodeURIComponent(String(locationId))}`,options
    );
  }


export const getLocationDetailsQueryKey = (segmentationId: SegmentationId,
    accountId: AccountId,
    locationId: LocationId,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/locations/${locationId}`] as const;
    }

    
export const getLocationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof locationDetails>>, TError = AxiosError<void>>(segmentationId: SegmentationId,
    accountId: AccountId,
    locationId: LocationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationDetailsQueryKey(segmentationId,accountId,locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationDetails>>> = ({ signal }) => locationDetails(segmentationId,accountId,locationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId && locationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type LocationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof locationDetails>>>
export type LocationDetailsQueryError = AxiosError<void>

export const useLocationDetails = <TData = Awaited<ReturnType<typeof locationDetails>>, TError = AxiosError<void>>(
 segmentationId: SegmentationId,
    accountId: AccountId,
    locationId: LocationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLocationDetailsQueryOptions(segmentationId,accountId,locationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchLocationDetails = async <TData = Awaited<ReturnType<typeof locationDetails>>, TError = AxiosError<void>>(
 queryClient: QueryClient, segmentationId: SegmentationId,
    accountId: AccountId,
    locationId: LocationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getLocationDetailsQueryOptions(segmentationId,accountId,locationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * Creates a registration composite, with a location for an account
 */
export const createCompositeWithLocation = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    locationRequest: LocationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RegistrationCompositeId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/locations`,
      locationRequest,options
    );
  }



export const getCreateCompositeWithLocationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: LocationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: LocationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompositeWithLocation>>, {segmentationId: SegmentationId;accountId: AccountId;data: LocationRequest}> = (props) => {
          const {segmentationId,accountId,data} = props ?? {};

          return  createCompositeWithLocation(segmentationId,accountId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompositeWithLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createCompositeWithLocation>>>
    export type CreateCompositeWithLocationMutationBody = LocationRequest
    export type CreateCompositeWithLocationMutationError = AxiosError<HttpValidationProblemDetails>

    export const useCreateCompositeWithLocation = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithLocation>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: LocationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createCompositeWithLocation>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;data: LocationRequest},
        TContext
      > => {

      const mutationOptions = getCreateCompositeWithLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    